import script from "./PaymentGatewayLogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentGatewayLogs.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentGatewayLogs.vue?vue&type=style&index=0&id=fe1c3b4c&lang=css"

const __exports__ = script;

export default __exports__